import certificatePdfApi from "../../api/pdf/certificatePdfApi";

const CertificatePdfService = {
  /**
   * 📄 Descarga el certificado DTE de la empresa activa.
   * GET /api/pdf/certificate
   */
  download: async (): Promise<{ blob: Blob; fileName: string | null }> => {
    const response = await certificatePdfApi.fetchBlob(""); // sin id, sin ruta extra

    return {
      blob: response.data,
      fileName: response.fileName || "Certificado_Codenova.pdf",
    };
  },
};

export default CertificatePdfService;
